import ScaleModal from './ScaleModal';

export default ScaleModal;